module.exports = __webpack_public_path__ + "static/img/listYT.85f9bf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/listYT.jpg
// module id = AkN0
// module chunks = 6